import { h } from 'preact';
import * as BaseComp from 'components/shared/closableTrailer/closableTrailer.js';
import Vimeo from 'components/shared/vimeo/vimeo.js';
import s from 'components/shared/closableTrailer/closableTrailer.sss';

export default class ClosableTrailer extends BaseComp.default {
	renderVimeoVideo() {
		return (
			<Vimeo
				class={s.vimeoPlayer}
				vimeoID={this.props.vimeoID}
				onPlayerReady={this.playerReady}
				autoplay={false}
				useTracking
				isClosableTrailer
			/>
		);
	}
}
